import React from 'react';
import { Role } from '../../consts';
import AccountMenu from './AccountMenu';

interface Props {
    role: Role;
}

export default function StaticAccountDropdown({ role }: Props) {
    return (
        <div
            className="top-level-nav__item top-level-nav__item--first top-level-nav__item--account"
            data-global-nav-detached-dropdown
            data-detached-dropdown
            data-detached-dropdown-location="down-right"
            data-detached-dropdown-location-forced
        >
            <a
                className="top-level-nav__item__link"
                href="/account/personal-information"
                data-no-link
                data-detached-dropdown-trigger
            >
                <span className="avatar avatar--extra-small">
                    <img alt="" className="avatar__image" src="/avatars/current-user/32" />
                </span>
            </a>
            <div data-detached-dropdown-content>
                <div data-detached-dropdown-content-inner>
                    <AccountMenu role={role} />
                </div>
            </div>
        </div>
    );
}
